import React, { memo, useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { IHomeProductsProps } from "../../models/interface";
import "./style.scss";
import { sections } from "../../services";
import RenderSection from "../renderSections";
import _ from "lodash";
import {
  HOME_PRODUCT_SECTION_IDS,
  LIMIT_SECTIONS,
  TOTAL_REQUEST,
} from "../../common/constant";
// import { FixedSizeList as List } from "react-window";
import InfiniteScroll from "react-infinite-scroller";
import { useDispatch, useSelector } from "react-redux";
import {
  getSections,
  selectOffset,
  selectSections,
  setSections,
} from "../../redux/reducers/slice/home";
import { List } from "antd";

const HomeProducts = memo((props: IHomeProductsProps) => {
  const sectionsData = useSelector(selectSections);
  const offset = useSelector(selectOffset);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (!sectionsData || !sectionsData.length) {
      dispatch(getSections(offset, LIMIT_SECTIONS));
    }
  }, []);

  const fetchData = (offset: number, limit: number, cb: any) => {
    const totalRequest = parseInt(localStorage.getItem(TOTAL_REQUEST) || "0");
    localStorage.setItem(TOTAL_REQUEST, (totalRequest - 1).toString());

    setLoading(true);
    sections.getSections(
      {
        ids: HOME_PRODUCT_SECTION_IDS.slice(offset, limit),
      },
      (data: any, err: any) => {
        if (data && data.data.length) {
          cb(_.sortBy(data.data, ["order"]));
        }
        localStorage.setItem(TOTAL_REQUEST, "0");
      }
    );
  };

  const handleInfiniteOnLoad = () => {
    if (offset <= 0) return;

    if (offset >= HOME_PRODUCT_SECTION_IDS.length) {
      setHasMore(false);
      setLoading(false);
      return;
    }

    fetchData(offset, offset + LIMIT_SECTIONS, (res: any) => {
      dispatch(setSections({ data: res, offset: offset + LIMIT_SECTIONS }));
      setLoading(false);
    });
  };

  return (
    <div className="kd-product-category-wrapper">
      <div className="kd-product-category-item">
        {sectionsData && sectionsData.length ? (
          <InfiniteScroll
            style={{ width: "100%" }}
            initialLoad={false}
            pageStart={0}
            loadMore={handleInfiniteOnLoad}
            hasMore={!loading && hasMore}
            threshold={2500}>
            <List
              dataSource={sectionsData}
              renderItem={(item: any) => (
                <List.Item key={item._id} className="section-item">
                  <RenderSection {...props} sectionItem={item} />
                </List.Item>
              )}></List>
          </InfiniteScroll>
        ) : null}
      </div>
    </div>
  );
});

export default HomeProducts;
